'use strict';

const Vue = require('vue');

const productConfiguratorInlineStore = {

    init: (VueX) => {
        const state = {
            parts: {},
            resources: {},
            productData: {},
            userConfiguration: {}
        };

        const getters = {
            parts: state => state.parts,
            resources: state => state.resources,
            productData: state => state.productData,
            userConfiguration: state => state.userConfiguration,
            partById: state => (id) => {
                return state.parts.find(part => part.id === id);
            },
            containerPart: state => () => { //bottle or candleholder
                return state.parts.find((part) => 'options' in part);
            },
            fillerPart: state => () => { //fragrance or wax
                return state.parts.find((part) => !('options' in part));
            },
            customerSelectedContainer: (state, getters) => {
                const containerPart = getters.containerPart();
                const selectedContainerId = state.userConfiguration.container;
                if (!selectedContainerId || !containerPart) {
                    return null;
                }
                return containerPart.options.find((container) => container.id === selectedContainerId);
            },
            customerSelectedFiller: (state, getters) => {
                const fillerPart = getters.fillerPart();
                const selectedFillerId = state.userConfiguration.filler;
                if (!selectedFillerId || !fillerPart) {
                    return null;
                }
                for (const category of Object.values(fillerPart.categories)) {
                    for (const option of Object.values(category.options)) {
                        if (option.id === selectedFillerId) {
                            return {
                                categoryName: category.name,
                                ...option
                            };
                        }
                    }
                }
            }
        };

        const mutations = {
            setParts(state, newVal) {
                state.parts = newVal;
            },

            setResources(state, newVal) {
                state.resources = newVal;
            },

            setProductData(state, newVal) {
                state.productData = newVal;
            },

            setUserConfiguration(state, newVal) {
                Vue.set(state.userConfiguration, newVal[0], newVal[1]);
            }
        };

        return new VueX.Store({
            state: state,
            getters: getters,
            mutations: mutations
        });
    }
};

module.exports = productConfiguratorInlineStore;
